import { ICommonOption } from "@/components/excel/schema/definiens/baseType";
import { IAreaOption } from "@/components/selector/area/AreaExclusiveCache";

export function assembleCommonDisabled(
  items: ICommonOption[],
  disabledList?: number[]
): ICommonOption[] {
  if (!Array.isArray(disabledList) || !disabledList.length) {
    return items;
  }
  items.forEach((it) => (it.disabled = disabledList.includes(it.value)));
  return items;
}
export function filterCommonHidden(
  items: ICommonOption[],
  hiddenList?: number[]
): ICommonOption[] {
  if (!Array.isArray(hiddenList) || !hiddenList.length) {
    return items;
  }
  return items.filter((it) => !hiddenList.includes(it.value));
}
export function filterCommonAllowed(
  items: ICommonOption[],
  allowedList?: number[]
): ICommonOption[] {
  if (!Array.isArray(allowedList) || !allowedList.length) {
    return items;
  }
  return items.filter((it) => allowedList.includes(it.value));
}
export function filterAreaHidden(items: IAreaOption[], hiddenList?: number[]) {
  if (!Array.isArray(hiddenList) || !hiddenList.length) {
    return items;
  }
  return items.filter((it) => !hiddenList.includes(it.id));
}
export function filterAreaAllowed(items: IAreaOption[], allowedList?: number[]) {
  if (!Array.isArray(allowedList) || !allowedList.length) {
    return items;
  }
  return items.filter((it) => allowedList.includes(it.id));
}
export function assembleAreaDisabled(
  items: IAreaOption[],
  disabledList?: number[]
) {
  if (!Array.isArray(disabledList) || !disabledList.length) {
    return items;
  }
  items.forEach((it) => (it.disabled = disabledList.includes(it.id)));
  return items;
}
